<template>
  <section>
    <label
      class="text-editor__label"
      v-text="$t(`labels.${fieldName}`)"
    ></label>

    <form-group :name="fieldName" class="mt-3">
      <VueEditor
        class="editor"
        v-model="form[fieldName]"
        slot-scope="{ attrs }"
        v-bind="attrs"
        :editorToolbar="customToolbar"
        v-input-validation="fieldName"
      />
    </form-group>

    <transition name="fadeIn" mode="in-out">
      <span class="editor__errors" v-if="serverErrors">{{
        serverErrors[fieldName] && serverErrors[fieldName][0]
      }}</span>
    </transition>

    <br />
    <v-btn
      :loading="loadingButton"
      @click.prevent="handleSubmit"
      :disabled="form[fieldName] === ''"
      class="primary my-3"
      type="submit"
      >{{ $t("button.save") }}</v-btn
    >
  </section>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { StoreData } from "@/helpers/apiMethods";

export default {
  name: "Editor",

  props: {
    fieldName: {
      type: String
    },
    locale: {
      type: String,
      default: "en"
    },
    form: {
      type: Object,
      default: () => {}
    },
    settings: { type: Object, default: () => {} }
  },
  components: {
    VueEditor
  },
  methods: {
    handleSubmit() {
      this.loadingButton = true;
      const reqData = {
        [this.fieldName]: this.form[this.fieldName],
        locale: this.locale,
        page_name: this.$route.name
      };
      StoreData({ reqName: "page-settings", data: reqData })
        .catch(err => console.log(err))
        .finally(() => (this.loadingButton = false));
    }
  },
  computed: {
    serverErrors() {
      return this.$store.getters.serverErrors;
    }
  },

  data() {
    return {
      loadingButton: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ["image"],
        [{ align: "" }, { align: "justify" }, { align: "right" }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ direction: "rtl" }]
      ]
    };
  }
};
</script>
